import { render, staticRenderFns } from "./Restoration2.vue?vue&type=template&id=66a14da8&scoped=true"
import script from "./Restoration2.vue?vue&type=script&lang=js"
export * from "./Restoration2.vue?vue&type=script&lang=js"
import style0 from "./Restoration2.vue?vue&type=style&index=0&id=66a14da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a14da8",
  null
  
)

export default component.exports